//
export default [
    {
        text        : 'COD INTERNO',
        align       : 'left',
        value       : 'internal_code',
    },
    {
        text        : 'NOMBRE',
        align       : 'left',
        value       : 'name',
        fieldType   : 'text',
        fieldOptions: {
            color   : 'red',
        },
    },
    {
        text        : 'ALIAS',
        align       : 'left',
        value       : 'alias_name',
        fieldType   : 'text',
        fieldOptions: {
            color   : 'red',
        },
    },
    {
        text        : 'CANTIDAD',
        align       : 'left',
        value       : 'quantity',
        editable    : true,
        fieldType   : 'text',
        fieldOptions: {
            color   : 'red',
        },
    },
]
